// Module
var code = "<ecv-cr-profile ecv-subject-id=\"crProfileVm.subjectId\"></ecv-cr-profile> ";
// Exports
var _module_exports = code;;
var path = 'app/common/cr-profile-page/cr-profile-page.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;